import { createStorefrontApiClient } from "@shopify/storefront-api-client";
export const shopifyProductMap = {
    og: "gid://shopify/ProductVariant/42524998992011",
    gr: "gid://shopify/ProductVariant/42525036904587",
    gv: "gid://shopify/ProductVariant/42524999090315",
    kb: "gid://shopify/ProductVariant/42524999188619",
    om: "gid://shopify/ProductVariant/42179480289419",
    lr: "gid://shopify/ProductVariant/42524999155851",
    lv: "gid://shopify/ProductVariant/42524999057547",
    ng: "gid://shopify/ProductVariant/42524999024779",
    nm: "gid://shopify/ProductVariant/42524998959243",
    nocreatinewatermelonpw: "gid://shopify/ProductVariant/42516337229963",
    nocreatinestrawberrypw: "gid://shopify/ProductVariant/42516337361035",
    decafwatermelonpw: "gid://shopify/ProductVariant/42516337197195",
    decafstrawberrypw: "gid://shopify/ProductVariant/42516337328267",
    histimwatermelonpw: "gid://shopify/ProductVariant/42516337098891",
    histimstrawberrypw: "gid://shopify/ProductVariant/42516337262731",
    lowstimwatermelonpw: "gid://shopify/ProductVariant/42516337164427",
    lowstimstrawberrypw: "gid://shopify/ProductVariant/42516337295499",
    // hydrations
    low_caff_mango: "gid://shopify/ProductVariant/42510248050827",
    low_nocaff_mango: "gid://shopify/ProductVariant/42510248116363",
    high_caff_mango: "gid://shopify/ProductVariant/42510248083595",
    high_nocaff_mango: "gid://shopify/ProductVariant/42510248149131",
    high_nocaff_mango_10: "gid://shopify/ProductVariant/42179479371915",
    low_caff_lemonlime: "gid://shopify/ProductVariant/42510248181899",
    low_nocaff_lemonlime: "gid://shopify/ProductVariant/42510248247435",
    high_caff_lemonlime: "gid://shopify/ProductVariant/42510248214667",
    high_nocaff_lemonlime: "gid://shopify/ProductVariant/42510248280203",
    low_caff_strawberrylemonade: "gid://shopify/ProductVariant/42179479371915",
    low_nocaff_strawberrylemonade: "gid://shopify/ProductVariant/42510247985291",
    high_caff_strawberrylemonade: "gid://shopify/ProductVariant/42510247952523",
    high_nocaff_strawberrylemonade: "gid://shopify/ProductVariant/42510248018059",
    greens_tropicalpineapple_28: "gid://shopify/ProductVariant/42681027887243",
    greens_lemonginger_28: "gid://shopify/ProductVariant/42681028116619",
    creatine: "gid://shopify/ProductVariant/42179479273611",
    collagen: "gid://shopify/ProductVariant/42179479175307",
    fiber: "gid://shopify/ProductVariant/42179479109771",
    blenderbottle: "gid://shopify/ProductVariant/42617633800331",
    wb221: "gid://shopify/ProductVariant/42619457896587",
    wb222: "gid://shopify/ProductVariant/42619462156427",
};
export const shopifyProductIds = {
    protein: 7525299060875,
    hydration: 7340944425099,
    preworkout: 7340944523403,
    creatine: 7340944326795,
    collagen: 7340944261259,
    fiber: 7340944195723,
    greens: 7340944162955,
};
export const shopifyProductPlans = {
    protein: {
        3: 1510703243,
        4: 1510768779,
        6: 1510670475,
        8: 1510736011,
    },
    hydration: {
        3: 1374519435,
        4: 1486553227,
        6: 1486585995,
        8: 1486618763,
    },
    bundle: {
        3: 1509490827,
        4: 1492254859,
        6: 1492222091,
        8: 1492287627,
    },
    preworkout: {
        3: 1410072715,
        4: 1374486667,
        6: 1486651531,
        8: 1486684299,
    },
    greens: {
        3: 1510539403,
        4: 1510637707,
        6: 1510572171,
        8: 1510604939,
    },
    fiber: {
        3: 1376878731,
        4: 1486454923,
        6: 1486520459,
        8: 1486487691,
    },
    collagen: {
        3: 1376845963,
        4: 1486356619,
        6: 1486389387,
        8: 1486422155,
    },
    creatine: {
        3: 1371406475,
        4: 1371439243,
        6: 1371504779,
        8: 1371472011,
    },
};
export const shopifyFlavorBoostsMap = {
    variety: {
        product: "7490993062027",
        variant: "42579625738379",
        externalPlanId: {
            3: 1489698955,
            4: 1489731723,
            6: 1489862795,
            8: 1489830027,
        },
    },
    caramel: {
        product: "7490991915147",
        variant: "42579619348619",
        externalPlanId: {
            3: 1489502347,
            4: 1489567883,
            6: 1489535115,
            8: 1489633419,
        },
    },
    chocolate: {
        product: "7490985263243",
        variant: "42579582713995",
        externalPlanId: {
            3: 1488912523,
            4: 1488978059,
            6: 1489010827,
            8: 1488945291,
        },
    },
    cinnamon: {
        product: "7490990538891",
        variant: "42579611484299",
        externalPlanId: {
            3: 1489666187,
            4: 1489436811,
            6: 1489797259,
            8: 1489895563,
        },
    },
    cookies: {
        product: "7490986934411",
        variant: "42579588645003",
        externalPlanId: {
            3: 1489109131,
            4: 1489043595,
            6: 1489076363,
            8: 1489174667,
        },
    },
    mocha: {
        product: "7490989293707",
        variant: "42579601555595",
        externalPlanId: {
            3: 1489338507,
            4: 1489764491,
            6: 1489404043,
            8: 1489928331,
        },
    },
    peanut: {
        product: "7490987458699",
        variant: "42579592085643",
        externalPlanId: {
            3: 1468301451,
            4: 1488846987,
            6: 1488814219,
            8: 1488879755,
        },
    },
    strawberry: {
        product: "7490988671115",
        variant: "42579598278795",
        externalPlanId: {
            3: 1489240203,
            4: 1489371275,
            6: 1489469579,
            8: 1489600651,
        },
    },
    vanilla: {
        product: "7490987950219",
        variant: "42579595231371",
        externalPlanId: {
            3: 1489141899,
            4: 1489207435,
            6: 1489305739,
            8: 1489272971,
        },
    },
};
export const proteinMap = {
    og: {
        sku: "OG14",
        variant: "42524998992011",
        qtyVariants: {
            1: "42681096700043",
            2: "42681098469515",
            3: "42681098797195",
        },
    },
    lr: {
        sku: "LR14",
        variant: "42524999155851",
        qtyVariants: {
            1: "42681096929419",
            2: "42681098666123",
            3: "42681098993803",
        },
    },
    nm: {
        sku: "NM14",
        variant: "42524998959243",
        qtyVariants: {
            1: "42681096667275",
            2: "42681098436747",
            3: "42681098764427",
        },
    },
    om: {
        sku: "OM14",
        variant: "42524998959243",
        qtyVariants: {
            1: "42681096667275",
            2: "42681098436747",
            3: "42681098764427",
        },
    },
    ng: {
        sku: "NG14",
        variant: "42524999024779",
        qtyVariants: {
            1: "42681096732811",
            2: "42681098502283",
            3: "42681098829963",
        },
    },
    lv: {
        sku: "LV14",
        variant: "42524999057547",
        qtyVariants: {
            1: "42681096798347",
            2: "42681098567819",
            3: "42681098895499",
        },
    },
    gv: {
        sku: "GV14",
        variant: "42524999090315",
        qtyVariants: {
            1: "42681096896651",
            2: "42681098633355",
            3: "42681098961035",
        },
    },
    kb: {
        sku: "KB14",
        variant: "42524999188619",
        qtyVariants: {
            1: "42681096994955",
            2: "42681098731659",
            3: "42681099059339",
        },
    },
    gr: {
        sku: "GR14",
        variant: "42525036904587",
        qtyVariants: {
            1: "42681096962187",
            2: "42681098698891",
            3: "42681099026571",
        },
    },
};
// export const bundleQuantityToVariantMap = {
//   1: "42682214678667",
//   2: "42682214711435",
//   3: "42682214744203",
// };
export const STORE_DOMAIN = "https://gainfulnew.myshopify.com";
export const PUBLIC_STOREFRONT_TOKEN = "a5b0cd2f9a7274cc28b92d0b4eeda19b";
export const storefrontClient = createStorefrontApiClient({
    storeDomain: STORE_DOMAIN,
    apiVersion: "2023-10",
    publicAccessToken: PUBLIC_STOREFRONT_TOKEN,
});
